<div class="title-model-cntr">
  <h3 >Dati Contrattuali:</h3>
  <h4 >Aggiungi le ore lavorative per i giorni della settimana.</h4>
</div>
<ct-model *ngIf="configuration" [configuration]="configuration"></ct-model>
